import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { axiosClient } from "../webServices/axiosInstance";
import { Loading, Notify } from "notiflix";
import { FaUserAlt } from "react-icons/fa";
import { FaLocationDot, FaMobileRetro, FaSchool } from "react-icons/fa6";
import { ResonanceLogoBlack } from "../data/ImageData";
import { ErrorMessage } from "@hookform/error-message";
import { IoIosSchool } from "react-icons/io";
import Congratulation from "./Congratulation";
import { SiGoogleclassroom } from "react-icons/si";

const studentCls = [
  { value: "8th", title: "8th" },
  { value: "9th", title: "9th" },
  { value: "10th", title: "10th" },
  { value: "11th", title: "11th" },
  { value: "12th", title: "12th" },
];

const studentSub = [
  {
    value: "JEE",
    title: "JEE",
  },
  {
    value: "NEET",
    title: "NEET",
  },
  {
    value: "Maths",
    title: "Maths",
  },
  {
    value: "Biology",
    title: "Biology",
  },
];

const Scholarship = ({ closeModel }) => {
  const [formstatus, setFormstatus] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const handleLogin = async (data) => {
    try {
      const res = await axiosClient().post("/resosat/enquiry/send", data);

      let response = res.data;
      if (!response.status) {
        Notify.failure(response.message);
        return;
      }
      reset();
      Loading.remove();
      Notify.success(response.message);
      setFormstatus(true);
    } catch (error) {
      Notify.failure(error.message);
      Loading.remove();
    }
  };

  return (
    <>
      {!formstatus ? (
        <section className="flex max-h-[70vh] items-center justify-center ">
          <div
          style={{scrollbarWidth:"none"}}
            className="border-2 flex-col flex rounded-xl max-h-[90vh] overflow-y-scroll  bg-white overflow-hidden p-4  h-fit"
            id="forn-container"
          >
            <div
              onClick={() => {
                closeModel(false);
              }}
              className="border-2 border-red-300 text-red-600 w-6 flex items-center justify-center font-bold hover:bg-red-600 hover:text-white cursor-pointer self-end hover:border-none duration-300 h-6 rounded-full"
            >
              ×
            </div>
            <div className="w-full ">
              <img
                src={ResonanceLogoBlack}
                className="h-10 my-2 mx-auto"
                alt="logo"
              />
              <h1 className="font-semibold relative text-black text-2xl uppercase text-center mt-4">
                <span className="absolute scale-110 -rotate-12 -top-4">
                  <IoIosSchool />
                </span>{" "}
                Get the Scholarship
              </h1>
              <h1 className="font-medium capitalize  text-indigo-500 text-lg text-center mt-2">
                fill the below given form to avail scholarship!
              </h1>
            </div>
            <form
              onSubmit={handleSubmit(handleLogin)}
              className="p-4  mt-4 w-full flex flex-col gap-y-6"
            >
              <div className="flex items-center gap-x-3  ">
                <FaUserAlt color="black" size={20} />
                <div className="w-full relative">
                  <input
                    {...register("studentname", {
                      required: "*name is required",
                    })}
                    type="text"
                    name="studentname"
                    autoComplete={false}
                    autoFocus={false}
                    className="w-full p-1 autofill:focus:bg-transparent!important focus:border-b-2 border-b text-black outline-none focus:border-black border-gray-500 bg-transparent text-xl"
                    placeholder="enter your full name"
                  />
                  <div className="text-red-600 absolute -bottom-6">
                    <ErrorMessage errors={errors} name="studentname" />
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-x-3 ">
                <FaSchool color="black" size={20} />
                <input
                  {...register("school")}
                  type="text"
                  autoComplete={false}
                  autoFocus={false}
                  className="w-full p-1 autofill:focus:bg-transparent!important focus:border-b-2 border-b text-black outline-none focus:border-black border-gray-500 bg-transparent text-xl"
                  placeholder="enter your school name"
                />
              </div>
              <div className="flex items-center gap-x-3 ">
                <SiGoogleclassroom color="black" size={20} />
                <select
                  {...register("standard")}
                  type="text"
                  autoComplete={false}
                  autoFocus={false}
                  className="w-full p-1 autofill:focus:bg-transparent!important focus:border-b-2 border-b text-black outline-none focus:border-black border-gray-500 bg-transparent text-xl"
                >
                  <option>select class</option>
                  {studentCls.map((opt, idx) => (
                    <option key={idx} value={opt.value}>
                      {opt.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex items-center gap-x-3 ">
                <SiGoogleclassroom color="black" size={20} />
                <select
                  {...register("subject")}
                  type="text"
                  autoComplete={false}
                  autoFocus={false}
                  className="w-full p-1 autofill:focus:bg-transparent!important focus:border-b-2 border-b text-black outline-none focus:border-black border-gray-500 bg-transparent text-xl"
                >
                  <option className="text-gray-400">select subject</option>
                  {studentSub.map((opt, idx) => (
                    <option key={idx} value={opt.value}>
                      {opt.title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex items-center gap-x-3 ">
                <FaLocationDot color="black" size={20} />
                <input
                  {...register("city")}
                  type="text"
                  autoComplete={false}
                  autoFocus={false}
                  className="w-full p-1 autofill:focus:bg-transparent!important focus:border-b-2 border-b text-black outline-none focus:border-black border-gray-500 bg-transparent text-xl"
                  placeholder="enter your city"
                />
              </div>

              <div className="flex items-center gap-x-3 ">
                <FaMobileRetro color="black" size={20} />
                <div className="w-full relative">
                  <input
                    {...register("mobile", {
                      required: "*mobile no is required",
                    })}
                    type="text"
                    maxLength={10}
                    autoComplete={false}
                    autoFocus={false}
                    className="w-full p-1 autofill:focus:bg-transparent!important focus:border-b-2 border-b text-black outline-none focus:border-black border-gray-500 bg-transparent text-xl"
                    placeholder="enter your mobile number"
                  />
                  <div className="text-red-600 absolute -bottom-6">
                    <ErrorMessage errors={errors} name="mobile" />
                  </div>
                </div>
              </div>

              {/* <div className="flex items-center gap-x-3 ">
                <MdMessage color="black" size={20} />
                <input
                  {...register("message")}
                  type="text"
                  autoComplete={false}
                  autoFocus={false}
                  className="w-full p-1 autofill:focus:bg-transparent!important focus:border-b-2 border-b text-black outline-none focus:border-black border-gray-500 bg-transparent text-xl"
                  placeholder="leave a message"
                />
              </div> */}

              <button className="flex mt-4 items-center hover:text-white-600  gap-2 p-2 border-none justify-center hover:bg-[#0a557d] duration-300 bg-[#0a557d] text-white font-semibold rounded-xl ">
                Submit
              </button>
            </form>
            <div>
              <p className="text-white text-center mt-4">
                create a new account?{" "}
                {/* <Link
                  className="text-blue-600 font-medium uppercase text-lg"
                  to={""}
                >
                  <abbr title="login username and password"> Register ↩</abbr>
                </Link> */}
              </p>
            </div>
          </div>
        </section>
      ) : (
        <Congratulation />
      )}
    </>
  );
};

export default Scholarship;
